import React from "react";
import { Activity, GitBranch, Database, MousePointerClick } from "lucide-react";

const InsightsSection = () => {
  const insights = [
    {
      icon: <GitBranch className="w-5 h-5 text-orange-500" />,
      text: "Fragmented care journeys reduce patient adherence and long-term outcomes.",
    },
    {
      icon: <Activity className="w-5 h-5 text-orange-500" />,
      text: "Continuous monitoring enables early intervention and better care decisions.",
    },
    {
      icon: <Database className="w-5 h-5 text-orange-500" />,
      text: "Disconnected data limits clinical effectiveness and slows decision-making.",
    },
    {
      icon: <MousePointerClick className="w-5 h-5 text-orange-500" />,
      text: "Simple, intuitive systems drive higher adoption across patients and providers.",
    },
  ];

  return (
    <section className="w-full py-12 md:py-16">
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
        <h2 className="font-semibold  mb-4">
          Insights That Shape Better Care
        </h2>
        <p className="  leading-relaxed">
          Our research reveals patterns and challenges across healthcare systems,
          helping us uncover opportunities to improve outcomes, efficiency, and
          patient engagement.
        </p>
      </div>

      {/* Cards */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-14">
        {insights.map((item, index) => (
          <div
            key={index}
            className="relative bg-[#EEF2FF] rounded-xl px-6 py-6 text-center flex flex-col items-center justify-center"
          >
            {/* Icon */}
            <div className="absolute -top-4 bg-white p-2 rounded-md shadow-sm border border-orange-100">
              {item.icon}
            </div>

            {/* Text */}
            <p className="  leading-relaxed">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InsightsSection;